<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60"><circle cx="30" cy="30" r="30" style="fill:#37b284"/><path d="M20234 3927v-8h-8v-4h8v-8h4v8h8v4h-8v8z" style="fill:#fff" transform="translate(-20206.004 -3887.004)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-free-use',
});
</script>
